import React from "react"
import { CartProvider } from "./src/context/CartContext"
import "./src/styles/global.css"

/**
 * Wrap the whole app in the cart provider so every page/component can
 * read and mutate the cart. This runs in the browser.
 */
export const wrapRootElement = ({ element }) => (
  <CartProvider>{element}</CartProvider>
)
